import Loadable from '../../components/loadable';

const ContactRecurringBookings = Loadable({
  loader: () => import('../../pages/contacts/contact_recurring_bookings'),
});

angular.module('gym').value('ContactRecurringBookings', ContactRecurringBookings);
